<template lang="html">
  <div class="login-form">

    <h1>Login</h1>

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"
    />

    <form @submit.prevent="submit">
      <Field
        label="Email Address"
        placeholder="joe.bloggs@email.com"
        @input="$v.resource.email.$touch()"
        v-model="resource.email"
        :error="emailError"/>

      <Field
        label="Password"
        type="password"
        @input="$v.resource.password.$touch()"
        v-model="resource.password"
        :error="passwordError"/>

      <div class="form-actions">
        <Btn primary isBlock :isDisabled="$v.$invalid">Log In</Btn>
        <router-link :to="{name: 'register'}">Need an account?</router-link>
        <router-link :to="{name: 'reset-password-init'}">Forgot your password?</router-link>
      </div>
    </form>

    <span class="login-notice" v-if="this.inviteSent">
      Please activate your account by clicking on the link we've just emailed to you.
    </span>
  </div>
</template>

<script>
import form from '@/mixins/form'
import notification from '@/mixins/notification'

import {errorMessages} from '@/lib/error_messages'
import {email, required} from 'vuelidate/lib/validators'

import Btn from '@/components/Btn'

export default {
  name: 'LoginForm',

  mixins: [form, notification],

  components: {
    Btn
  },

  props: ['accountActivated', 'inviteSent', 'passwordReset'],

  computed: {
    ...errorMessages(['email', 'password'])
  },

  validations: {
    resource: {
      email: {email, required},
      password: {required}
    }
  },

  mounted() {
    if (this.accountActivated) {
      this.triggerNotification('success', 'account', 'activated', true)
    }

    if (this.inviteSent) {
      this.triggerNotification('success', 'email', 'sent')
    }

    if (this.passwordReset) {
      this.triggerNotification('success', 'password has been', 'changed')
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.login-form
  margin: auto
  @extend %card
  position: relative
  overflow: hidden
  padding: $gap-x-large
  border-radius: 5px
  max-width: 95%
  width: 100%

  @include media($media-gt-small)
    width: 450px

  .login-notice
    font-size: 14px
    text-align: center
    display: block
    margin-top: $gap-medium
    color: $color-success
    font-weight: bold

  h1
    margin-top: 0
    margin-bottom: $gap-large

  input
    width: 100%

  .form-actions
    text-align: center

    a
      text-transform: uppercase
      font-size: 9px
      display: inline-block
      margin: $gap-medium $gap-small 0

    .btn
      display: block
      margin: 0 auto $gap-small
</style>
